import { render, staticRenderFns } from "./RegionalSidebar.vue?vue&type=template&id=593ef6e1&scoped=true&"
import script from "./RegionalSidebar.vue?vue&type=script&lang=js&"
export * from "./RegionalSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ef6e1",
  null
  
)

export default component.exports